<script setup lang="ts">
	defineProps<{
		modelValue: string | undefined | null
		placeholder?: string
	}>()

	const emits = defineEmits<{
		(event: 'search'): void
		(event: 'clear'): void
	}>()
	const searchValue = defineModel<string | undefined | null>()

	const clearSearch = () => {
		searchValue.value = ''
		emits('clear')
	}
</script>

<template>
	<div class="relative w-[265px]">
		<tools-icon
			dir="line"
			icon="search-normal"
			class="absolute left-[20px] top-[12px] translate-x-[-6px]"
			:height="20"
			:width="20"
		/>
		<input
			v-model="searchValue"
			type="search"
			class="custom-input w-full appearance-none !bg-white !pl-10 pr-2 hover:appearance-none"
			:placeholder="placeholder ?? 'Search'"
			@keypress.enter="emits('search')"
		/>
		<button
			v-if="!!searchValue"
			type="button"
			class="absolute bottom-0 right-1.5 top-0 z-10 my-auto bg-transparent text-2xl"
			@click="clearSearch"
		>
			<tools-icon
				dir="arrows"
				icon="cancel"
				:height="16"
				:width="16"
				path-class="stroke-blue-700"
				stroke="current"
			/>
		</button>
	</div>
</template>
